import React from 'react'
import { connect } from 'react-redux'
import PageElement from './PageElement'


class FormPage extends React.Component {

  render() {
    const { mission_page, real_answer } = this.props
    return (
      <div>
        {mission_page.page_elements.map((element) => {
          let real_answer_for_element = null
          if (real_answer && real_answer.page_elements) {
            real_answer.page_elements.forEach((x) => {
              if (x.id === element.id) {
                real_answer_for_element = x
              }
            })
          }
          return (
            <PageElement
              key={element.id}
              element={element}
              real_answer={real_answer_for_element}
            />
          )
        })}
      </div>
    )
  }

}

FormPage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
  real_answer: React.PropTypes.shape({}),
}

const mapStateToProps = state => ({
  ...state.missions,
})

const mapDispatchToProps = () => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(FormPage)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/index.jsx